<script setup lang="ts">
import { ref } from 'vue'
import Modal from '@/components/ui/Modal.vue'
import { extractError } from '@/api/client'
import { useKeysStore } from '@/stores/keys'

const keys = useKeysStore()
const infoOpen = ref(false)
const loading = ref(false)
const status = ref('')
const statusClass = ref('text-muted')

async function rebuild() {
  if (loading.value) return
  loading.value = true
  status.value = 'Пересборка…'
  statusClass.value = 'text-muted'
  try {
    const res = await keys.rebuild()
    if (!res.success) {
      status.value = res.message || 'Не удалось пересобрать ключи'
      statusClass.value = 'text-danger'
      return
    }
    status.value = res.keys_count != null
      ? `Готово (${res.keys_count} ключей)`
      : 'Готово'
    statusClass.value = 'text-success'
  } catch (e) {
    status.value = extractError(e, 'Не удалось пересобрать ключи')
    statusClass.value = 'text-danger'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="panel flex h-full flex-col gap-3 !py-4 !px-5">
    <h3 class="flex items-center gap-2 text-sm font-bold">
      Управление ключами
      <button
        type="button"
        class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-white-dark/50 text-xs font-bold text-white-dark transition hover:border-primary hover:text-primary"
        aria-label="Справка об управлении ключами"
        title="Справка"
        @click="infoOpen = true"
      >
        ?
      </button>
    </h3>
    <button
      type="button"
      class="btn btn-sm btn-outline-primary w-full"
      :disabled="loading"
      @click="rebuild"
    >
      <i class="bi bi-arrow-clockwise" />
      {{ loading ? 'Пересборка…' : 'Пересобрать ключи' }}
    </button>
    <small v-if="status" class="text-xs" :class="statusClass">
      {{ status }}
    </small>
  </div>

  <Modal
    :open="infoOpen"
    title="Управление ключами"
    max-width="lg"
    @close="infoOpen = false"
  >
    <div class="space-y-4 text-sm leading-relaxed text-[#1f2937]">
      <p>
        Если параметры протоколов изменились (например, ключ шифрования), нажмите кнопку для
        принудительной пересборки всех ключей.
      </p>
    </div>

    <template #footer>
      <button type="button" class="btn btn-primary" @click="infoOpen = false">
        Закрыть
      </button>
    </template>
  </Modal>
</template>
